@file:kotlin.js.JsExport
package com.narbase.letsgo.web.routing.domain.admin.passengers

import com.narbase.letsgo.router.EndPoint
import com.narbase.letsgo.web.dto.passengers.ExtendedPassengerDto


object GetPassengerByVoipExtensionEndpoint : EndPoint<GetPassengerByVoipExtensionEndpoint.Request, GetPassengerByVoipExtensionEndpoint.Response>() {
    class Request(
        val extension: String
    )

    class Response(
        val extendedPassengerDto: ExtendedPassengerDto?,
    )
}